// cart-add-refresh.js
// created by ch
// Bridges add-to-cart to the theme's cart-drawer:refresh event,
// and prevents the empty-cart flash by suppressing the drawer's
// open animation until refresh completes.

(function () {
  if (window.__i150CartAddRefreshInstalled) return;
  window.__i150CartAddRefreshInstalled = true;

  var originalFetch = window.fetch;
  var refreshTimer = null;
  var pendingAddInFlight = false;

  // Hide the drawer body during the refresh window so the empty state
  // never visibly renders. We only hide the contents, not the drawer
  // chrome — the drawer can still open with its header visible and
  // a spinner shows in the body while we wait for the refresh.
  var styleEl = document.createElement('style');
  styleEl.textContent = [
    '.wt-cart__drawer.i150-refreshing .wt-cart__drawer__body {',
    '  position: relative;',
    '}',
    '.wt-cart__drawer.i150-refreshing .wt-cart__drawer__body > *,',
    '.wt-cart__drawer.i150-refreshing .wt-cart__drawer__footer {',
    '  visibility: hidden !important;',
    '}',
    '.wt-cart__drawer.i150-refreshing .wt-cart__drawer__body::after {',
    '  content: "";',
    '  position: absolute;',
    '  top: 40%;',
    '  left: 50%;',
    '  width: 32px;',
    '  height: 32px;',
    '  margin: -16px 0 0 -16px;',
    '  border: 3px solid rgba(0,0,0,0.1);',
    '  border-top-color: #f07c1f;',
    '  border-radius: 50%;',
    '  visibility: visible !important;',
    '  animation: i150-spin 0.8s linear infinite;',
    '}',
    '@keyframes i150-spin {',
    '  to { transform: rotate(360deg); }',
    '}'
  ].join('\n');
  document.head.appendChild(styleEl);

  function setRefreshing(on) {
    var drawer = document.querySelector('.wt-cart__drawer');
    if (!drawer) return;
    drawer.classList.toggle('i150-refreshing', !!on);
  }

  function scheduleDrawerRefresh(delayMs) {
    pendingAddInFlight = true;
    setRefreshing(true);
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      document.dispatchEvent(
        new CustomEvent('cart-drawer:refresh', { bubbles: true })
      );
      // The refresh fetch is async. Give it a beat to swap HTML in,
      // then reveal. refreshCartDrawer doesn't expose a "done" hook,
      // so we just wait a small fixed time after dispatching.
      setTimeout(function () {
        setRefreshing(false);
        pendingAddInFlight = false;
      }, 350);
    }, delayMs);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string'
      ? input
      : (input && input.url) || '';
    var method = (init && init.method) || (input && input.method) || 'GET';
    var isInternalAppstleCall = init && init.__internalCall;

    var isCartMutation =
      typeof url === 'string' &&
      method.toUpperCase() === 'POST' &&
      (url.indexOf('/cart/add') !== -1 ||
       url.indexOf('/cart/change') !== -1 ||
       url.indexOf('/cart/update') !== -1 ||
       url.indexOf('/cart/clear') !== -1);

    // Mark refreshing as soon as we see the mutation start, so if the
    // drawer opens between now and refresh-completion, it'll be hidden.
    if (isCartMutation && !isInternalAppstleCall) {
      setRefreshing(true);
      pendingAddInFlight = true;
    }

    var promise = originalFetch.apply(this, arguments);

    if (isCartMutation) {
      promise.then(function () {
        scheduleDrawerRefresh(isInternalAppstleCall ? 250 : 1400);
      }).catch(function () {
        setRefreshing(false);
        pendingAddInFlight = false;
      });
    }

    return promise;
  };
})();